import { render, staticRenderFns } from "./PrescriptionModal.vue?vue&type=template&id=58a94897&"
import script from "./PrescriptionModal.vue?vue&type=script&lang=js&"
export * from "./PrescriptionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports